import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { api } from "@/redux/api";
import { buildFacilityPath, getFacilityContext } from "@/utils/route-context";
import ServiceRequestList from "@/containers/service-request/ServiceRequestList";

export default function FacilityServiceRequestPage() {
  const selectedFacilityId = useSelector((state) => state.Facility?.selected?.Id);
  const facilityContext = useSelector((state) => getFacilityContext(state));
  const { facilityId: routeFacilityId } = useParams();
  const facilityIds = useMemo(() => {
    const currentFacilityId = Number(routeFacilityId) || selectedFacilityId;
    return currentFacilityId ? [currentFacilityId] : [];
  }, [routeFacilityId, selectedFacilityId]);
  const loadRequests = useCallback(
    (selectedFacilityIds, params) => api.getFacilityServiceRequests(selectedFacilityIds, params),
    []
  );
  const loadCategories = useCallback(
    () => api.getFacilityServiceRequestCategories(),
    []
  );
  const getDetailPath = useCallback(
    (record) => {
      return buildFacilityPath(`service-request-detail/${record.id}`, facilityContext) || "/switch-view";
    },
    [facilityContext]
  );

  return (
    <ServiceRequestList
      facilityIds={facilityIds}
      loadRequests={loadRequests}
      loadCategories={loadCategories}
      getDetailPath={getDetailPath}
      showRequesterColumn
    />
  );
}
